import { render, staticRenderFns } from "./HandleCookies.vue?vue&type=template&id=5b2f8e08&"
import script from "./HandleCookies.vue?vue&type=script&lang=js&"
export * from "./HandleCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports